// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing067({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/067/25010901.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/067/25010902.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/067/25010903.gif`}
      formFieldColor="white"
      qTitleColor="#0202bc"
      qOptionColor="blue"
      privacyMessage="개인정보수집에 동의하시는 분만 '상담 문의'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/consultInquiryButton3.png`}
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
      eventDates={true}
      carrotTag={true}
    />
  );
}

export default Randing067;
